var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoInstallation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#00080c;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1391.141 -3567.859)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -1391.14, 3567.86)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.793,104.217h1.615V84.631h-1.615Zm4.721,3.863h1.61V80.773h-1.61Zm25.2-15.729H243.1V96.5h1.613ZM240,88.492h-1.613v11.868H240Zm-33.029,3.86h-1.613V96.5h1.613Zm4.721-3.86h-1.614v11.868h1.614Zm17.259,19.589h1.615V80.773h-1.615Zm4.716-3.863h1.618V84.631h-1.618Zm-9.436,7.723h1.613V76.91h-1.613Z",
    transform: "translate(-1584.816 3502.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInstallation);
export default __webpack_public_path__ + "static/media/logo-installation.28423e3cee472554608c231d2323dc5f.svg";
export { ForwardRef as ReactComponent };